'use strict';
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // Browser globals
    factory();
  }
}(this, function () {
  return function initHistoryStorage(maxHistoryLength) {
    maxHistoryLength = maxHistoryLength || 500;

    var itemStorage = {
      items: [],
      times: {},
      objects: []
    };

    if (localStorage.getItem('riaHistoryItems')) {
      try {
        itemStorage.items = JSON.parse(localStorage.getItem('riaHistoryItems')) || [];
      } catch(error) {
        itemStorage.items = [];
      }
    }

    if (localStorage.getItem('riaHistoryTimes')) {
      try {
        itemStorage.times = JSON.parse(localStorage.getItem('riaHistoryTimes')) || {};
      } catch(error) {
        itemStorage.times = {};
      }
    }

    if (localStorage.getItem('riaHistoryObjects')) {
      try {
        itemStorage.objects = JSON.parse(localStorage.getItem('riaHistoryObjects')) || [];
      } catch(error) {
        itemStorage.objects = [];
      }
    }

    function toUnixTime() {
      return Math.floor(new Date().getTime() / 1000);
    }

    /**
     * Додає в історію перегляду запис
     *
     * @param {number} id - Тип контенту
     * @param {number} type - Id контенту
     */
    function addToStorage(id, type) {
      var key = type+':'+id,
          pos = itemStorage.items.lastIndexOf(key);

      if (pos !== -1) {
        itemStorage.items.splice(pos, 1);
      }
      itemStorage.items.unshift(key);
      localStorage.setItem('riaHistoryItems', JSON.stringify(itemStorage.items.slice(0, maxHistoryLength)));
      itemStorage.times[key] = toUnixTime();
      localStorage.setItem('riaHistoryTimes', JSON.stringify(itemStorage.times));
    }

    function massAddToStorage(ids, type) {
      for (var idx in ids) {
        var id = ids[idx];
        var key = type+':'+id;
        var pos = itemStorage.items.lastIndexOf(key);

        if (pos != -1) {
          itemStorage.items.splice(pos, 1);
        }
        itemStorage.items.unshift(key);
        itemStorage.times[key] = toUnixTime();
      }

      localStorage.setItem('riaHistoryItems', JSON.stringify(itemStorage.items));
      localStorage.setItem('riaHistoryTimes', JSON.stringify(itemStorage.times));
    }

    function getLelekaItems(limit) {
      limit = limit || maxHistoryLength;
      if (itemStorage && itemStorage.items && Array.isArray(itemStorage.items)) {
        return itemStorage.items.slice(0, limit);
      }
      return [];
    }

    /**
     * Отримати список ID, переглянутого контенту по типу контенту
     *
     * @param {number} type  - Тип контенту
     * @return {*[]}
     */
    function getIdsByType(type) {
      if (itemStorage.objects && Array.isArray(itemStorage.objects)) {
        return itemStorage.objects.reduce(function (ids, historyItem) {
          if (historyItem.item_type_id === type && historyItem.content_id && typeof historyItem.content_id === 'number') {
            ids.push(historyItem.content_id);
          }
          return ids;
        }, []);
      }

      var arr = itemStorage.items.filter(function (item) {
        var arr = item.split(':');
        return arr[0] == type;
      });
      return arr.map(function (item) {
        var arr = item.split(':');
        return Number(arr[1]);
      });
    }

    /**
     * get view history "v3"
     * get and merge format v2 (riaHistoryTimes) and v3 (riaHistoryObjects) to format v3
     * @returns {[{
     *  item_type_id: Number,
     *  content_id: Number|Object,
     *  timestamp: Number
     * }]}
     */
    function getHistoryObjects() {
      var riaHistory;
      try {
        riaHistory = localStorage.getItem('riaHistoryObjects');
      } catch (error) {
        return [];
      }

      var riaHistoryObjects;
      if (riaHistory) {
        try {
          riaHistoryObjects = JSON.parse(riaHistory) || [];
        } catch (e) {
          return [];
        }
      }

      if (riaHistoryObjects && Array.isArray(riaHistoryObjects)) {
        return riaHistoryObjects.filter(function(item) {
          switch (item.item_type_id) {
            case 21: return (item.content.mark && item.content.model);
            default: return true;
          }
        });
      }
      return [];
    }

    /**
     * @returns {{item_type_id: Number, content_id: (Number|Object), timestamp: Number}[]}
     */
    function lelekaHistoryObjects() {
      // todo: deprecate and delete after 2021-08-01 {{
      // convert v2 to format v3 and clean old localstorage keys
      if (!itemStorage) {
        initHistoryStorage();
      }
      if (itemStorage.times && Object.keys(itemStorage.times).length) {
        var historyOld = [];
        Object.keys(itemStorage.times).forEach(function(typeValueKey) {
          var typeValue = typeValueKey.split(':');
          var timestamp = itemStorage.times[typeValueKey];

          var item_type_id = typeValue[0];
          var content_id = typeValue[1];

          historyOld.push({
            item_type_id: Number(item_type_id),
            content_id: Number(content_id),
            timestamp: Number(timestamp),
          });
        });

        localStorage.setItem('riaHistoryObjects', JSON.stringify(
            getHistoryObjects().concat(historyOld).slice(0, 10)
        ));
        localStorage.removeItem('riaHistoryItems');
        localStorage.removeItem('riaHistoryTimes');
      }
      // todo: deprecate and delete after 2021-08-01 }}
      return getHistoryObjects();
    }

    /**
     * пишет в хранилище
     * @param {Number} item_type_id content type id
     * @param {Number|Object} payload
     */
    function addHistoryObject(item_type_id, payload) {
      var historyItem = {
        item_type_id: Number(item_type_id),
        timestamp: new Date().getTime(),
      };
      if (typeof payload === 'number') {
        historyItem.content_id = payload;
      } else if ((typeof payload === 'object')) {
        historyItem.content = Object.entries(payload).reduce(function (fixed, pair) {
          var key = pair[0];
          var value = pair[1];
          fixed[key] = Number(value);
          return fixed;
        }, {});
      } else {
        return;
      }

      var riaHistoryObjects = getHistoryObjects();
      riaHistoryObjects.unshift(historyItem);
      localStorage.setItem('riaHistoryObjects', JSON.stringify(
          riaHistoryObjects.slice(0, maxHistoryLength)
      ));
    }

    // Clean old history format
    if (localStorage.getItem('viewHistory')) {
      var ids = JSON.parse(localStorage.getItem('viewHistory')) || [];
      localStorage.removeItem('viewHistory');
      massAddToStorage(ids, 1);
    }

    if (localStorage.getItem('viewNaHistory')) {
      var ids = JSON.parse(localStorage.getItem('viewNaHistory')) || [];
      localStorage.removeItem('viewNaHistory');
      massAddToStorage(ids, 2);
    }

    if (localStorage.getItem('viewedNewss')) {
      var ids = JSON.parse(localStorage.getItem('viewedNewss')) || [];
      localStorage.removeItem('viewedNewss');
      massAddToStorage(ids, 3);
    }

    if (localStorage.getItem('viewEquipHistory')) {
      var ids = JSON.parse(localStorage.getItem('viewEquipHistory')) || [];
      localStorage.removeItem('viewEquipHistory');
      massAddToStorage(ids, 4);
    }

    window.riaHistoryStorage = {
      version: '2.0',
      add: addToStorage,
      addHistoryObject: addHistoryObject,
      lelekaList: getLelekaItems,
      lelekaHistoryObjects: lelekaHistoryObjects,
      getIdsByType: getIdsByType,
    };
  };
}));
